/* eslint-disable react-hooks/exhaustive-deps */
import React, { HTMLProps, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'src/store';
import cn from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import './styles.scss';
import { DepositionStatus } from 'src/dataFactory/depositionFactory';
import { getDepositions } from 'src/redux/depositionRedux/actions';
import { ErrorService } from 'src/services';
import { IMAGES } from 'src/appConfig/images';
import appConfig from 'src/appConfig';
import { Grid, Image, Input, Text, View } from 'src/components/common';
import DepositionItemPlacehoder from './DepositionItem/DepositionItemPlacehoder';
import DepositionItem from './DepositionItem';
import { isEmpty } from 'src/validations';
import { GetDepositionsParam } from 'src/redux/depositionRedux/types';
import { getRandomId } from 'src/utils';

const ManageRepository: React.FC<Props> = ({ type, className, getDepositions, ...props }) => {
  const [depositions, setDepositions] = useState<any[]>([]);
  const [skipDepo, setSkipDepo] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [total, setTotal] = useState<number | null>(null);
  const [isFetchingFirstData, setIsFetchingFirstData] = useState(true);
  const [search, setSearch] = useState('');
  const [searchText, setSearchText] = useState('');

  const handleError = (err: any) => {
    setIsFetchingFirstData(false);
    ErrorService.handler(err);
  };

  const handleSuccess = (depositions: any[], total: number, skip: number) => {
    setIsFetchingFirstData(false);
    if (skip === 0) {
      setDepositions(depositions);
    } else {
      setDepositions(state => state.concat(depositions));
    }
    setTotal(total);
  };

  const fetchData = (skip: number = skipDepo, take: number = appConfig.ROWS_PER_PAGE_WIDER) => {
    getDepositions(
      { skip, take, search: searchText } as GetDepositionsParam,
      (depositions: any[], total: number) => handleSuccess(depositions, total, skip),
      handleError,
    );

    setSkipDepo(skip => skip + take);
  };

  //Infinite scroll component only trigger fetchData when scroll down to 80% viewport (default)
  //So, we need to show depositions over screen's height on first time
  const initDepositions = () => {
    fetchData(0, appConfig.ROWS_PER_PAGE_WIDER);
  };

  useEffect(() => {
    initDepositions();
  }, [searchText]);

  //detect when loaded all depositions and stop infinite scroll
  useEffect(() => {
    if (total === depositions.length) setHasMore(false);
  }, [total, depositions]);

  const handleSearchChange = (e: any) => {
    const search = e.target.value;
    if (isEmpty(search)) {
      setSearchText(search);
    }
    setSearch(search);
  };
  const handleSearch = () => {
    setSearchText(search);
  };
  const emptyComponent = (
    <View className="cmp-deposition-list-item__empty-ctn mt-72" align="center">
      <Image className="mb-16 cmp-deposition-files__empty" src={IMAGES.iconFolderEmpty} alt="icon empty folder" />
      <Text size={16} className="has-text-centered has-text-grey">
        There are no depositions at the moment!
      </Text>
    </View>
  );

  return (
    <View className={cn('cmp-deposition-list-item mt-40 mb-40', className)} {...props}>
      <Text size={36}>Repository</Text>
      <Input
        containerClassName="mb-24 mt-24"
        placeholder="Search by Case Name, Deposition Name, Deposition ID or User Name"
        iconName="ic_search"
        onChange={handleSearchChange}
        onKeyDown={event => {
          const key = event.key;
          if (key === 'Enter') {
            handleSearch();
          }
        }}
        value={search}
        onIconClick={handleSearch}
      />
      {!isFetchingFirstData && depositions.length === 0 && emptyComponent}

      <InfiniteScroll
        className="cmp-deposition-list-item__scroll-list"
        dataLength={depositions.length}
        next={fetchData}
        hasMore={hasMore}
        loader={
          <Grid.Wrap>
            <Grid.Item className="cmp-deposition-list-item__item" key={getRandomId()}>
              <DepositionItemPlacehoder />
            </Grid.Item>
            <Grid.Item key={getRandomId()}>
              <DepositionItemPlacehoder />
            </Grid.Item>
          </Grid.Wrap>
        }
        endMessage={null}>
        <Grid.Wrap className="cmp-deposition-list__container">
          {depositions.map(depo => (
            <Grid.Item key={depo.id}>
              <DepositionItem deposition={depo} />
            </Grid.Item>
          ))}
        </Grid.Wrap>
      </InfiniteScroll>
    </View>
  );
};

type DepositionType = 'all' | DepositionStatus;

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  HTMLProps<HTMLDivElement> & {
    type: DepositionType;
    searchText?: string;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {
  getDepositions,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageRepository);
